<template>
  <Aside
    :toggle-by="toggleBy"
    @oncancel="OnCancel"
    cancel-text="Cancel"
    width="1024px"
  >
    <WarehouseUpdate
      tabbed
      v-if="toggleBy"
      :title="title"
      :uuid="uuid"
      @onsave="OnSave"
      @oncancel="OnCancel"
      cancel-text="Cancel"
    />
  </Aside>
</template>
<script>
import { Util } from "@/helpers/utilities";
import WarehouseUpdate from "@/components/ui/warehouse/WarehouseUpdate.vue";
import Aside from "@/components/ui/Aside.vue";
export default {
  components: {
    WarehouseUpdate,
    Aside,
  },
  props: {
    toggleBy: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Add Warehouse",
    },
  },
  emits: ["onsave", "oncancel"],
  setup(_, { emit }) {
    const OnSave = () => {
      emit("onsave");
    };
    const OnCancel = () => {
      emit("oncancel");
    };
    return {
      Util,
      OnSave,
      OnCancel,
    };
  },
};
</script>